module.exports = __webpack_public_path__ + "img/report-default-image.03fd3a05.png";